<kendo-grid
  #infrastructureRegulatory
  [data]="view | async"
  (cellClick)="cellClickHandler($event)"
  (cellClose)="cellCloseHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [navigable]="true"
  [resizable]="true"
  [sort]="gridState.sort"
  [sortable]="{ mode: 'multiple' }"
  (dataStateChange)="onStateChange($event)"
  filterable="menu"
  [filter]="filter"
  (filterChange)="handlerFilter($event)"
  class="infrastructure-regulatory-permitting-draggable"
  [rowClass]="rowCallback"
>
  <ng-template kendoGridToolbarTemplate>
    <button
      kendoButton
      class="k-button"
      [disabled]="!infrastructureRegulatoryPermittingService.hasChanges()"
      (click)="cancelChanges(infrastructureRegulatory)"
      [primary]="true"
    >
      Cancel
    </button>
    <button [icon]="'plus'" kendoGridAddCommand [primary]="true" [disabled]="!canEditPerformanceBod"></button>
  </ng-template>
  <kendo-grid-column title="" field="" [hidden]="true" [width]="1">
    {{ rowLoaded() }}
  </kendo-grid-column>
  <kendo-grid-column field="performanceBodId" title="PerdoformanceBodId" [hidden]="true"></kendo-grid-column>
  <kendo-grid-column field="performanceBodPackagesId" title="Package Name" [editable]="true">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter
        [isPrimitive]="false"
        [field]="column.field"
        textField="name"
        valueField="id"
        [filterService]="filterService"
        [currentFilter]="filter"
        [data]="performanceBodPackagesList"
      >
      </multicheck-filter>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ getPerformanceBodPackages(dataItem.performanceBodPackagesId)?.name }}
    </ng-template>
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-column="column"
      let-formGroup="formGroup"
      let-isNew="isNew"
    >
      <kendo-dropdownlist
        [data]="performanceBodPackagesList"
        [defaultItem]="{ id: null, name: 'Select item...' }"
        textField="name"
        valueField="id"
        [valuePrimitive]="true"
        [formControl]="formGroup.get('performanceBodPackagesId')"
        (valueChange)="changePackage($event, dataItem, formGroup)"
      >
      </kendo-dropdownlist>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column
    field="description"
    title="Regulatory/Permitting Description"
    [width]="150"
    [editable]="true"
  ></kendo-grid-column>
  <kendo-grid-column
    field="mpdApdFeeRequirements"
    title="MDP/APD/FEE Requirements"
    [width]="150"
    [editable]="true"
  ></kendo-grid-column>
  <kendo-grid-column field="airPermits" title="Air Permits" [width]="150" [editable]="true"></kendo-grid-column>
  <kendo-grid-column field="rowPermits" title="ROW Permits" [width]="150" [editable]="true"></kendo-grid-column>
  <kendo-grid-column
    field="regulatoryPermit"
    title="Regulatory Permits"
    [width]="150"
    [editable]="true"
  ></kendo-grid-column>
  <kendo-grid-column
    field="requestedConstructionStartDate"
    title="Requested Construction Start Date"
    [width]="150"
    [editable]="true"
    editor="date"
    format="MM/dd/yyyy"
    [filterable]="filterable"
    filter="date"
  >
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.requestedConstructionStartDate | date: 'MM/dd/yyyy' }}
    </ng-template>
    <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-column="column" let-formGroup="formGroup">
      <kendo-datepicker
        [value]="dataItem.requestedConstructionStartDate"
        [format]="'MM/dd/yyyy'"
        [formControl]="formGroup.get('requestedConstructionStartDate')"
      ></kendo-datepicker>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column
    field="comments"
    title="Comments"
    [width]="150"
    [editable]="true"
    [hidden]="false"
  ></kendo-grid-column>
  <kendo-grid-command-column title="" [width]="150">
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button kendoGridRemoveCommand [primary]="true" [icon]="'minus'" [disabled]="!canEditPerformanceBod"></button>
      <button kendoGridSaveCommand [primary]="true">Add</button>
      <button kendoGridCancelCommand [primary]="true">Cancel</button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>
